import { render } from "./tipcom.vue?vue&type=template&id=69947761&scoped=true&ts=true"
import script from "./tipcom.vue?vue&type=script&lang=ts"
export * from "./tipcom.vue?vue&type=script&lang=ts"

import "./tipcom.vue?vue&type=style&index=0&id=69947761&lang=scss&scoped=true"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69947761"]])

export default __exports__